'use strict';exports.__esModule = true;var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _validate = require('../../utils/validate');
var _services = require('../../services');
var _clearNumber = require('../../helpers/clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);
var _constants = require('../../constants');
var _packagesData = require('../../packagesData');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var validate = function validate(values, _ref) {var selectedPackage = _ref.selectedPackage,isAgent = _ref.isAgent,editedProperty = _ref.editedProperty,isForeign = _ref.isForeign;
  var errors = {};var _values$floor =
  values.floor,floor = _values$floor === undefined ? {} : _values$floor,_values$contacts = values.contacts,contacts = _values$contacts === undefined ? {} : _values$contacts;
  var isLend = values.property_type === 'land';

  var errorHandler = function errorHandler(type, key) {var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Required';
    if (!errors.contacts) {
      errors.contacts = {};
    }
    if (!errors.contacts[type]) {
      errors.contacts[type] = {};
    }
    errors.contacts[type][key] = error;
  };

  var checkContact = function checkContact(type) {
    var email = (0, _get2.default)(contacts, 'secondary.email');
    var keys = {
      primary: ['email', 'name', 'phone'],
      secondary: [].concat(email ? ['email'] : [], ['name', 'phone']) };

    var contact = (0, _get2.default)(contacts, type, {});

    var virtualNumber = contact.virtual;
    var shouldCheckNameChars = !virtualNumber || virtualNumber === 'other';

    keys[type].forEach(function (key) {
      if (key !== 'email' && !contact[key]) {
        errorHandler(type, key);
      } else if (key === 'email' && contact[key] && !(0, _validate.emailRegexValidation)(contact.email)) {
        errorHandler(type, 'email');
      }
    });
  };

  if (contacts.primary) {
    checkContact('primary');
  }
  if (contacts.secondary) {
    checkContact('secondary');
  }

  if (!isLend) {
    var isCottage = values.property_type === 'cottage';
    var isVilla = values.property_type === 'villa';

    if (!floor.on_the && floor.on_the !== 0 || (isCottage || isVilla) && floor.on_the === 0 ||
    !isCottage && !isVilla && floor.out_of && floor.on_the > floor.out_of) {
      errors.floor = Object.assign({},
      errors.floor, {
        on_the: 'Required' });

    }
    if (!isCottage && !isVilla && !floor.out_of && floor.out_of !== 0) {
      errors.floor = Object.assign({},
      errors.floor, {
        out_of: 'Required' });

    }
    if (+values.rooms === 0 || !values.rooms) {
      errors.rooms = 'Required';
    }

    if (values.construction_year && values.construction_year < 1800) {
      errors.construction_year = 'Required';
    }
  }

  if (values.area && (+values.area.base === 0 || !values.area.base)) {
    errors.area = Object.assign({},
    errors.area, {
      base: 'Required' });

  }

  var price = (0, _clearNumber2.default)(values.price);
  var minBuyPrice = isForeign ? 4 : 6;
  var minRentPrice = isForeign ? 2 : 3;

  if (+price === 0 || !values.price) {
    errors.price = 'Required';
  } else {
    var option = values.search_option;

    if (option === _constants.optionTypes.buy && price.length < minBuyPrice) {
      errors.price = isForeign ? 'Minimum 4 digits' : 'Minimum 6 digits';
    }

    if (option === _constants.optionTypes.rent && price.length < minRentPrice) {
      errors.price = isForeign ? 'Minimum 2 digits' : 'Minimum 3 digits';
    }
  }

  if (!values.address || !(0, _get2.default)(values.address, 'en.city_name') || !(0, _get2.default)(values.address, 'he.city_name')) {
    errors.address = 'Required';
  }

  if (values.balconies && values.balconies_area) {
    var filtered = values.balconies_area.filter(function (item) {return item;});
    if (filtered.length && filtered.length !== +values.balconies) {
      if (!errors.balconies_area) {errors.balconies_area = [];}
      values.balconies_area.forEach(function (item, index) {
        if (!item) {
          errors.balconies_area[index] = 'Required';
        }
      });
    }
  }

  if (values.vr_link) {
    var link = values.vr_link.toLowerCase();
    var hosts = ['matter', 'matterport', 'holomax', 'treedis', 'mpembed', 'veert', 're-max-time', 'vr-360-tour', 'brodex'];

    if (!link.startsWith('https://') || !hosts.some(function (host) {return link.includes(host);})) {
      errors.vr_link = 'Not valid';
    }
  }

  var packages = (0, _packagesData.getPackages)(isAgent);
  var currentPackage = packages.find(function (item) {return item.id === selectedPackage.checked;}) || {};
  var isTopPromoted = (0, _get2.default)(editedProperty, 'is_top_promoted');
  var isTopPackage = currentPackage.type === _packagesData.packageTypes.TOP;

  if ((isTopPackage || isTopPromoted) && (!values.images || !values.images.length)) {
    errors.images = 'Required';
  }

  if (!(0, _isEmpty2.default)(errors)) {
    errors._error = Object.assign({}, errors);
  }

  return errors;
};exports.default =

validate;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishForm/PublishValidate.js
// module id = 1249
// module chunks = 0